import {__} from "./__";

export const getCountries = () => {
    return {
        sk: __('Slovensko'),
        cz: __('Česká republika'),
        hu: __('Maďarsko'),
        pl: __('Poľsko'),
        ro: __('Rumunsko'),
        cy: __('Cyprus'),
        at: __('Rakúsko'),
        be: __('Belgicko'),
        bg: __('Bulharsko'),
        de: __('Nemecko'),
        dk: __('Dánsko'),
        ee: __('Estónsko'),
        en: __('USA'),
        es: __('Španielsko'),
        fi: __('Fínsko'),
        fr: __('Francúzsko'),
        gr: __('Grécko'),
        hr: __('Chorvátsko'),
        ie: __('Írsko'),
        it: __('Taliansko'),
        lt: __('Litva'),
        lu: __('Luxembursko'),
        lv: __('Lotyšsko'),
        mt: __('Malta'),
        nl: __('Holandsko'),
        pt: __('Portugalsko'),
        se: __('Švédsko'),
        si: __('Slovinsko'),
    };
};
